import { jsx as _jsx } from "react/jsx-runtime";
import { createPortal } from "react-dom";
import { useMediaQuery } from "react-responsive";
import { UserIndicationButton, } from "./components/UserIndicationButton/UserIndicationButton";
export const UserActions = ({ tabletUserNameRef, isEnabledUserIndication, isEnabledUserNameForIndication, ...props }) => {
    const MEDIUM_WIDTH = 1280;
    const SMALL_WIDTH = 768;
    const isBelowDesktopBreakpoint = useMediaQuery({
        query: `(min-width: ${SMALL_WIDTH}px) and (max-width: ${MEDIUM_WIDTH - 1}px)`,
    });
    const userActionElement = (_jsx(UserIndicationButton, { isEnabledUserIndication: isEnabledUserIndication, isEnabledUserNameForIndication: isEnabledUserNameForIndication, ...props }));
    if (isEnabledUserIndication && isEnabledUserNameForIndication && isBelowDesktopBreakpoint) {
        if (tabletUserNameRef.current) {
            return createPortal(userActionElement, tabletUserNameRef.current);
        }
    }
    return userActionElement;
};
//# sourceMappingURL=UserActions.js.map